import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/store';
import toast from 'react-hot-toast';

export default function AuthCallback() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const setToken = useAuth(s => s.setToken);

  useEffect(() => {
    const t = sp.get('token');
    if (!t) { toast.error('Login failed'); return nav('/login'); }
    setToken(t).then(() => { toast.success('Welcome! 🎉'); nav('/feed', { replace: true }); });
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-ink-50">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl grad-brand grid place-items-center text-white text-2xl font-black animate-float mx-auto">W</div>
        <p className="mt-4 text-ink-500 font-semibold">Signing you in…</p>
      </div>
    </div>
  );
}